// The ticketing backend returns attachment download URLs as a relative path:
//   /api/attachments/{id}?dl={signed-token}
// Since ACC-502 the ticketing client is served from web-front (the Forecast
// origin), so that relative path resolves against the Forecast origin — which has
// no /api/attachments route — and falls through to the SPA, returning index.html
// instead of the file. We rewrite it to the Forecast graphql same-origin proxy
// route (server.js `/ticketing-attachment/:id`), which streams the bytes from the
// ticketing backend. The signed `?dl=` token is preserved verbatim.
//
// This returns a path WITHOUT a leading slash so callers append it to
// DirectApi.graphqlServerEndpoint(...) (which yields an origin with a trailing
// slash, like the other authenticated asset URLs — fileSrc, companyLogoSrc, …).

const ATTACHMENTS_PREFIX = '/api/attachments/';
const PROXY_PREFIX = 'ticketing-attachment/';

export function attachmentProxyPath(downloadUrl: string): string {
	if (!downloadUrl.startsWith(ATTACHMENTS_PREFIX)) {
		return downloadUrl;
	}
	return PROXY_PREFIX + downloadUrl.slice(ATTACHMENTS_PREFIX.length);
}
